// ConfirmationModal.js
import React from 'react';

const ConfirmationModal = ({ isOpen, onClose, onGoBack, onNewForm }) => {
  if (!isOpen) return null; 

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-gray-600 bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-center mb-4">Form Submitted Successfully</h2>
        <p className="text-center mb-6">Thank you for submitting the form. What would you like to do next?</p>
        <div className="flex justify-around">
          <button
            onClick={onGoBack}
            className="py-2 px-4 bg-gray-500 text-white rounded-md hover:bg-gray-600"
          >
            Go Back to Home
          </button>
          <button
            onClick={onNewForm}
            className="py-2 px-4 bg-purple-600 text-white rounded-md hover:bg-purple-700"
          >
            Start a New Form
          </button>
        </div>
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
        >
          X
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
